import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { InternalService } from "./internal.service";
import { BugReportPayload } from "../models/imadata/BugReportPayloadInterface";
import { AuthService } from "./auth.service";
/**
 * Servicio para gestionar el envío y consulta de reportes de bugs.
 * Extiende InternalService para heredar manejo de errores.
 */
@Injectable()
export class BugReportsService extends InternalService {
  /**
   * Constructor: inyecta dependencias necesarias.
   */
  constructor(http: HttpClient, router: Router, authService: AuthService) {
    super(http, router, authService);
  }

  /**
   * Envía un reporte de bug al backend.
   * El título se ajusta automáticamente con la fecha y la marca "Error de usuario".
   * @param payload Objeto con la información del bug report.
   * @returns Observable con la respuesta del backend.
   */
  postBugReport(payload: BugReportPayload): Observable<any> {
    const now = new Date();
    const fecha = now.toISOString().replace('T', ' ').substring(0, 19);
    const formData = new FormData();
    Object.keys(payload).forEach(key => {
      if (key != 'screenshots') {
        formData.append(key, (payload as any)[key]);
      } else {
        (payload.screenshots || []).forEach((file, index) => {
          formData.append('screenshots', file, file.name);
        });
      }
    });
    let token = localStorage.getItem('token');
    if (token) token = JSON.parse(token);

    const authHeader = 'Bearer ' + (token || '');
    const headers = new HttpHeaders().set('Authorization', authHeader);

    return this.http
      .post(`${environment.apiUrl}/bug-reports/post-bug-report/`, formData, { headers })
      .pipe(catchError(this.handleError.bind(this)));
  }

  /**
   * Obtiene la lista de reportes de bugs del backend.
   * @param filter (Opcional) Filtros para la consulta.
   * @returns Observable con la lista de reportes.
   */
  getBugReports(filter?: any): Observable<any> {
    let token = localStorage.getItem('token');
    if (token) token = JSON.parse(token);

    let params = '';

    const authHeader = 'Bearer ' + (token || '');
    const headers = new HttpHeaders().set('Authorization', authHeader);

    return this.http
      .get(`${environment.apiUrl}/bug-reports/get-bug-reports/${params}`, { headers })
      .pipe(catchError(this.handleError.bind(this)));
  }

  /**
   * Obtiene los detalles de un reporte de bug por su ID.
   * @param bugReportId ID del reporte de bug.
   * @returns Observable con los detalles del reporte.
   */
  getBugReportById(bugReportId: string): Observable<any> {
    let token = localStorage.getItem('token');
    if (token) token = JSON.parse(token);
    const authHeader = 'Bearer ' + (token || '');
    const headers = new HttpHeaders().set('Authorization', authHeader);
    let params = '?id=' + bugReportId;
    return this.http
      .get(`${environment.apiUrl}/bug-reports/get-bug-unique-report/${params}`, { headers })
      .pipe(catchError(this.handleError.bind(this)));
  }
}

